module.exports = __webpack_public_path__ + "img/碘元素作用02.f7650f1f.webp";